<template>
  <UiModal
    :is-shown="isOpen"
    is-footer-hidden
    :title="t('regions_in_country_popup.title')"
    :size="UiModalSize.M"
    is-header-fixed
    is-scrollbar-width-ignored
    @close="closeHandler"
  >
    <template #content>
      <div class="regions-list">
        <a
          v-for="(reg, index) in regions"
          :key="index"
          :href="link(reg)"
          class="regions-item"
        >
          <img
            :src="reg.image.cover"
            class="regions-item__img"
          />
          {{ reg.name_ru }}
        </a>
      </div>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
  import { UiModal, UiModalSize } from '@experience/core-modal-ui';
  import type { MappedRegionsInCountryInfo } from '@/entities/regionsInCountry/types/regionsInCountry.ts';
  import { useI18n } from '@experience/i18n';
  import ru from '../../i18n/ru.json';
  import { withMfsDomain } from '@/shared/lib/withMfsDomain';

  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });
  interface Props {
    regions: MappedRegionsInCountryInfo[];
    isOpen: boolean;
  }

  interface Emits {
    (e: 'close'): void;
  }

  const emits = defineEmits<Emits>();

  const closeHandler = () => {
    emits('close');
  };

  defineProps<Props>();

  const link = (region: MappedRegionsInCountryInfo) => {
    const country = region?.url?.params?.country;
    const regionSlug = region?.url?.params?.regionSlug;
    const url = `/tours/${country}/${regionSlug}/`;

    return withMfsDomain(url);
  };
</script>

<style scoped lang="scss">
  @use '@experience/shared/dist/assets/adaptivity' as adaptivity;

  .regions-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    @include adaptivity.mobile {
      grid-template-columns: 1fr;
    }
  }

  .regions-item {
    display: flex;
    gap: 0 8px;
    align-items: center;
    color: var(--alias-color-text-default);
    font-size: 17px;
    line-height: 24px;
    text-decoration: none;
  }

  .regions-item__img {
    display: block;
    object-fit: cover;
    width: 48px;
    height: 48px;
    border-radius: 8px;
  }
</style>
